import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { courseQuizRes, courseQuizTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseQuiz'
import { PropagateLoader } from 'react-spinners'
import { FieldArray, FormikProvider, useFormik } from 'formik'
import { CourseQuizSchema } from './CourseManagementSchema'
import { quizTimerRes, quizTimerTodo } from '../../LMS_Redux/LMS_Slices/Course/QuizTimer'
import { submitQuizRes, submitQuizTodo } from '../../LMS_Redux/LMS_Slices/Course/SubmitQuiz'
import Swal from 'sweetalert2'
import { Spinner } from 'react-bootstrap'

export default function CourseQuiz(props) {

    const { state } = useLocation()

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.courseQuiz && state.courseQuiz.data && state.courseQuiz.data.data)
    const start_quiz_id = useSelector(state => state.startQuiz && state.startQuiz.data && state.startQuiz.data.data)
    // const timer = useSelector(state => state.quizTimer && state.quizTimer.data && state.quizTimer.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [breakLoading, setBreakLoading] = useState(false)
    // console.log(start_quiz_id)

    var content_data = []

    const quiz_data = data && data.questionData && data.questionData.map((value) => content_data.push({
        question_id: value && value.questionData && value.questionData.id,
        ans: '',
        question_object: value.questionData
    }))

    const initialValues = {

        training_id: data && data.user_training_id,
        course_id: data && data.course_id,
        quiz_id: data && data.quiz_id,
        learner_quiz_id: start_quiz_id && start_quiz_id.id,
        passing_marks: start_quiz_id && start_quiz_id.passing_marks,
        total_marks: start_quiz_id && start_quiz_id.total_marks,
        fk_training_id: start_quiz_id && start_quiz_id.fk_training_id,
        order: state && state.order,

        quiz: data ? content_data : [],
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: CourseQuizSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log(values)
            submit_quiz(values, action)
        },
    })

    const submit_quiz = (values, action) => {
        Swal.fire({
            title: 'Quiz Submission',
            text: `Are you sure want to Submit Quiz?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data)
                // setLoading(true)
                setSpinner(true)
                dispatch(submitQuizTodo(values)).then(() => submit_response(action))
            }
        })
    }

    const submit_response = (action) => {
        if (submitQuizRes && submitQuizRes.success) {
            Swal.fire(
                'Quiz Status',
                submitQuizRes.message,
                'success'
            )
            action.resetForm()
            setSpinner(false)
            navigate('/submit_quiz', { state: submitQuizRes.data && submitQuizRes.data[0] && submitQuizRes.data[0].learner_quiz_id })
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: submitQuizRes.message,
            })
            setSpinner(false)
        }
    }

    window.onbeforeunload = (event) => {
        const e = event
        // Cancel the event
        e.preventDefault();
        if (e) {
            e.returnValue = ''; // Legacy method for cross browser support
        }
        return ''; // Legacy method for cross browser support
    };

    const course_quiz_res = () => {
        if (courseQuizRes && courseQuizRes.success) {
            setLoading(false)
            setBreakLoading(false)
            startTimer()
        } else {
            setBreakLoading(false)
        }
    }

    useEffect(() => {
        props.setSidebar(false)
        setLoading(true)
        setBreakLoading(true)
        dispatch(quizTimerTodo({ "time": state && state.max_time_allowed })).then(() => {
            if (quizTimerRes && quizTimerRes.success) {

                var SS = parseInt(quizTimerRes.data && quizTimerRes.data.second)
                setTime(SS)

                dispatch(courseQuizTodo({ "course_id": start_quiz_id && start_quiz_id.course_id, "quiz_id": start_quiz_id && start_quiz_id.quiz_id })).then(() => course_quiz_res())

            } else {
                setBreakLoading(false)
            }
        })

        if (window.location.pathname == "/course_quiz") {
            // console.log(window.history)
            window.history.pushState(null, null, window.location.href)

            window.onpopstate = function () {
                window.history.go(1);
            }
        }

        return () => {

        }

    }, [])

    const [time, setTime] = useState();
    const [warning, setWarning] = useState(false);

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const formatNumber = num => (num < 10 ? `0${num}` : num);

        return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(remainingSeconds)}`;
        // const hours = Math.floor(seconds / 3600);
        // const minutes = Math.floor(seconds / 60);
        // const remainingSeconds = seconds % 60;
        // const formattedMinutes = String(minutes).padStart(2, '0');
        // const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        // return `${formattedMinutes}:${formattedSeconds}`;
    };

    const startTimer = () => {

        let timer = setInterval(() => {
            setTime((prevTime) => {
                if (prevTime > 1) {
                    return prevTime - 1;
                } else {
                    clearInterval(timer);
                    setWarning(true);
                    setTime(0)
                    // return 0
                    Swal.fire({
                        title: 'Time Up',
                        text: `Your Time is Up!!.`,
                        icon: 'warning',
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonColor: '#105684',
                        cancelButtonColor: '#9d9d9d',
                        confirmButtonText: 'Ok',
                        backdrop: true,
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/learner_course_list')
                        }
                    })
                }
            });
        }, 1000)
    };


    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header align-items-center' style={{ justifyContent: 'space-between' }}>
                    <div>
                        <span className='icon1'>Learning Module Management / </span>
                        <span className='icon2'>Learning Module Quiz</span>
                    </div>

                    <div className='d-lg-flex mt-2 mt-lg-0'>
                        {loading ? '' :
                            <h4>{formatTime(time)}</h4>
                        }
                    </div>
                </div>

                {loading && breakLoading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    !loading && !breakLoading ?
                        <FormikProvider value={formik}>
                            <form method="post" onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>

                                <FieldArray
                                    name="quiz"
                                    render={(arrayHelpers) => (
                                        <>
                                            {formik.values.quiz.map((field, index) => (
                                                // console.log(field)
                                                <div className='card mb-2' key={index}>
                                                    <div className='card-header'>
                                                        <span style={{ fontWeight: '500', fontSize: '16px' }}>{field && field.question_object && field.question_object.question} </span>
                                                    </div>
                                                    <div className='card-body' style={{ backgroundColor: 'aliceblue' }}>
                                                        <div className="row">

                                                            {(field.question_object && field.question_object.option1) || (field.question_object && field.question_object.image_option1) ?
                                                                <div className="col-md-3">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input form_checkbox" type="radio"
                                                                            name={`quiz[${index}].ans`}
                                                                            value='A'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        {field.question_object.option1 &&
                                                                            <label className="form-check-label" htmlFor="">
                                                                                {field.question_object.option1}
                                                                            </label>
                                                                        }
                                                                        {field.question_object.image_option1 &&
                                                                            <div style={{ height: '20vh' }}>
                                                                                <img src={process.env.REACT_APP_IMAGE_URL + field.question_object.image_option1} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                : ''
                                                            }

                                                            {(field.question_object && field.question_object.option2) || (field.question_object && field.question_object.image_option2) ?
                                                                <div className="col-md-3">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input form_checkbox" type="radio"
                                                                            name={`quiz[${index}].ans`}
                                                                            value='B'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        {field.question_object.option2 &&
                                                                            <label className="form-check-label" htmlFor="">
                                                                                {field.question_object.option2}
                                                                            </label>
                                                                        }
                                                                        {field.question_object.image_option2 &&
                                                                            <div style={{ height: '20vh' }}>
                                                                                <img src={process.env.REACT_APP_IMAGE_URL + field.question_object.image_option2} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                : ''
                                                            }

                                                            {(field.question_object && field.question_object.option3) || (field.question_object && field.question_object.image_option3) ?
                                                                <div className="col-md-3">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input form_checkbox" type="radio"
                                                                            name={`quiz[${index}].ans`}
                                                                            value='C'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        {field.question_object.option3 &&
                                                                            <label className="form-check-label" htmlFor="">
                                                                                {field.question_object.option3}
                                                                            </label>
                                                                        }
                                                                        {field.question_object.image_option3 &&
                                                                            <div style={{ height: '20vh' }}>
                                                                                <img src={process.env.REACT_APP_IMAGE_URL + field.question_object.image_option3} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                : ''
                                                            }

                                                            {(field.question_object && field.question_object.option4) || (field.question_object && field.question_object.image_option4) ?
                                                                <div className="col-md-3">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input form_checkbox" type="radio"
                                                                            name={`quiz[${index}].ans`}
                                                                            value='D'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        {field.question_object.option4 &&
                                                                            <label className="form-check-label" htmlFor="">
                                                                                {field.question_object.option4}
                                                                            </label>
                                                                        }
                                                                        {field.question_object.image_option4 &&
                                                                            <div style={{ height: '20vh' }}>
                                                                                <img src={process.env.REACT_APP_IMAGE_URL + field.question_object.image_option4} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                : ''
                                                            }

                                                            {(field.question_object && field.question_object.option5) || (field.question_object && field.question_object.image_option5) ?
                                                                <div className="col-md-3">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input form_checkbox" type="radio"
                                                                            name={`quiz[${index}].ans`}
                                                                            value='E'
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                        {field.question_object.option5 &&
                                                                            <label className="form-check-label" htmlFor="">
                                                                                {field.question_object.option5}
                                                                            </label>
                                                                        }
                                                                        {field.question_object.image_option5 &&
                                                                            <div style={{ height: '20vh' }}>
                                                                                <img src={process.env.REACT_APP_IMAGE_URL + field.question_object.image_option5} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                : ''
                                                            }

                                                        </div>

                                                    </div>
                                                    {formik.touched.quiz && formik.touched.quiz[index] && formik.touched.quiz[index].ans && formik.errors.quiz && formik.errors.quiz[index] && formik.errors.quiz[index].ans ?
                                                        <div className='card-footer'>
                                                            <span className='text-danger form_label'> {formik.errors.quiz[index].ans}</span>
                                                        </div>
                                                        : null
                                                    }
                                                </div>
                                            ))}
                                        </>
                                    )}
                                />

                                <div className='text-end'>
                                    <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                        {spinner ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='ms-2'
                                            />
                                            : ''
                                        }</button>
                                </div>
                            </form>

                        </FormikProvider>
                        :
                        loading && !breakLoading ?
                            <div className='wrapper-admin'>
                                <div className='text-center'>
                                    <h5>You are not allowed to view this page.</h5>
                                </div>
                            </div>
                            : ''
                }
            </div>
        </>
    )
}
